import React from "react";
import { PhoneCall, Search, FileCheck, Hammer } from "lucide-react";

const steps = [
  {
    icon: <PhoneCall size={28} />,
    title: "Free Consultation",
    desc: "We begin with a detailed discussion to understand your waterproofing issues, site conditions, and requirements. Our experts guide you with the best possible solution before any work starts."
  },
  {
    icon: <Search size={28} />,
    title: "Site Inspection & Diagnosis",
    desc: "Our technical team visits your site to inspect leakage points, moisture levels, cracks, and structural conditions using professional tools and proven inspection methods."
  },
  {
    icon: <FileCheck size={28} />,
    title: "Customized Solution Plan",
    desc: "Based on the inspection, we design a personalized waterproofing plan with the right materials, methods, timeline, and transparent cost estimation."
  },
  {
    icon: <Hammer size={28} />,
    title: "Professional Execution",
    desc: "Our trained technicians execute the work using premium-grade materials and modern technology, ensuring clean application and minimal disturbance."
  }
];

const HowWeWork = () => {
  return (
    <section className="bg-[#f8f9fb] py-32 px-4 md:px-10">
      {/* Header */}
      <div className="text-center mb-20">
        <span className="text-amber-600 tracking-[0.3em] text-xs font-bold uppercase block mb-3">
          Our Process
        </span>
        <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-5">
          How We Work
        </h2>
        <p className="max-w-3xl mx-auto text-gray-600 text-lg">
          We follow a systematic and transparent process to deliver reliable,
          long-lasting waterproofing solutions with guaranteed satisfaction.
        </p>
      </div>

      {/* Steps – Horizontal 4 Cards */}
      <div className="max-w-7xl mx-auto flex flex-wrap justify-center gap-8">
        {steps.map((step, i) => (
          <div
            key={i}
            className="relative bg-white rounded-2xl shadow-xl p-8 w-full md:w-[22%] text-center group hover:-translate-y-3 transition-transform duration-500"
          >
            {/* Step number */}
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-amber-600 text-white flex items-center justify-center font-bold shadow-lg">
              {i + 1}
            </div>

            {/* Icon */}
            <div className="w-16 h-16 mx-auto mb-6 mt-6 rounded-2xl bg-amber-50 flex items-center justify-center text-amber-600 group-hover:scale-110 transition-transform">
              {step.icon}
            </div>

            <h3 className="text-lg md:text-xl font-semibold mb-3">
              {step.title}
            </h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              {step.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowWeWork;
